import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class SnackbarService {

  constructor(private snackBar: MatSnackBar) {
  }

  handleError(errorMessage: string) {
    this.snackBar.open(errorMessage, null, {
      duration: 4000
    });
  }

  showSnackbar(message: string) {
    this.snackBar.open(message, null, {
      duration: 4000
    });
  }
}
